import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, PoolDto, PoolReferenceDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import PoolInline, { PoolInlineProps } from "./PoolInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: PoolDto | PoolReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<PoolInlineProps>;
}

export default function PoolLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.PoolRead]}
      to={ROUTE_PATH.POOL_VIEW(entity?.id || entityId || "")}
      content={<PoolInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
